import React from "react";
import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function PricingPage() {
  const { t } = useTranslation();

  const plans = [
    // ... ваши предыдущие 6 планов без изменений ...
    {
      name: "Start",
      price: "5.500",
      period: t("startPlanLimit"),
      ads: t("startPlanads"),
      description: false,
      features: t("startPlanfeatures", { returnObjects: true }),
      color: "bg-[#006674]",
    },
    {
      name: "Basic",
      price: "14.900",
      period: t("basicPlanLimit"),
      ads: t("basicPlanads"),
      description: t("plansDescription"),
      features: t("basicPlanfeatures", { returnObjects: true }),
      color: "bg-[#006674]",
    },
    {
      name: "Basic Pro",
      price: "44.900",
      period: t("basicProPlanLimit"),
      ads: t("basicProPlanads"),
      description: t("plansDescription"),
      features: t("BasicProPlanfeatures", { returnObjects: true }),
      color: "bg-[#006674]",
    },
    {
      name: "Silver",
      price: "49.900",
      period: t("SilverPlanLimit"),
      ads: t("SilverPlanads"),
      description: t("plansDescription"),
      features: t("SilverPlanfeatures", { returnObjects: true }),
      color: "bg-[#006674]",
      starSize: "w-6 h-6",
    },
    {
      name: "Gold",
      price: "98.900",
      period: t("GoldPlanLimit"),
      ads: t("GoldPlanads"),
      description: t("plansDescription"),
      features: t("GoldPlanfeatures", { returnObjects: true }),
      color: "bg-[#006674]",
      starSize: "w-8 h-8",
    },
    {
      name: "Premium",
      price: "365.000",
      period: t("PremiumPlanLimit"),
      ads: t("PremiumPlanads"),
      description: t("plansDescription"),
      features: t("PremiumPlanfeatures", { returnObjects: true }),
      color: "bg-[#006674]",
      starSize: "w-10 h-10",
    },
    // Последний ТОП план
    {
      name: t("topJobName"),
      price: "9.900",
      period: t("topJobLimit"),
      ads: t("topJobAds"),
      description: false,
      features: t("topJobFeatures", { returnObjects: true }),
      color: "bg-[#006674]",
      starSize: "w-10 h-10",
      isFullWidth: true, // Флаг для растягивания
    },
  ];

  return (
    <div className="min-h-screen py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-16">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-2xl md:text-4xl uppercase font-semibold text-white mb-4"
        >
          {t("plansminiTitle")}
        </motion.h1>
        <p className="text-white text-xl">{t("plansTitle")}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 max-w-[1300px] mx-auto items-stretch">
        {plans.map((plan, index) => (
          <motion.div
            key={plan.name}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            whileHover={{ y: -10 }}
            className={`relative backdrop-blur-lg bg-[#006674]/10 rounded-3xl text-white shadow-xl border-[3px] border-white/10 flex flex-col  overflow-hidden h-full 
              ${plan.isFullWidth ? "md:col-span-2 lg:col-span-3" : ""}`}
          >
            {/* Шапка плана */}
            <div className={`flex justify-between ${plan.color} py-6 px-6 rounded-t-[20px] items-center shrink-0`}>
              <div className="w-full">
                <div className="flex items-center justify-between w-full gap-2">
                  <h3 className="text-2xl md:text-3xl uppercase font-black text-white leading-none">
                    {plan.name}
                  </h3>
                  {plan.starSize && (
                    <Star className={`${plan.starSize} fill-white text-white shrink-0`} />
                  )}
                </div>
                <p className="text-md mt-3 opacity-90 font-medium">
                  {plan.ads} / {plan.period}
                </p>
                <div className="text-2xl font-black text-white mt-1">
                  {plan.price} ֏
                </div>
              </div>
            </div>

            {/* Контентная часть */}
            <div className="px-7 pt-8 pb-8 flex-grow flex flex-col justify-between">
              <div className={`mb-10 ${plan.isFullWidth ? "grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4" : "space-y-4"}`}>
                {plan.description && (
                  <p className="mb-6 flex justify-start items-start gap-2 col-span-full">
                    <Star className="fill-white w-4 h-4 mt-1 text-white shrink-0" />
                    {t("plansDescription")}
                  </p>
                )}

                {Array.isArray(plan.features) ? (
                  plan.features.map((feature, i) => (
                    <div key={i} className="flex items-center gap-3">
                      <div className="mt-1 bg-[#006674] border border-white rounded-full p-0.5 shrink-0">
                        <Check className="w-3.5 h-3.5" />
                      </div>
                      <span className="text-sm leading-tight opacity-90">
                        {feature}
                      </span>
                    </div>
                  ))
                ) : (
                  <p className="text-xs italic opacity-50">Loading features...</p>
                )}
              </div>

              <button className="w-full py-4 rounded-2xl font-bold bg-[#006674] text-white border border-white/10 hover:bg-[#007a8a] hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 shrink-0 shadow-lg">
                {t("planButton")}
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}